import { useDispatch } from "react-redux";
import { Transition } from "@headlessui/react";
import { Fragment } from "react";

import { updateUserSettingsByUserID } from "actions/userSettings";

import useTheme from "hooks/useTheme";
import useNotification from "hooks/useNotification";

import EuroIcon from "theme/icons/Euro";
import AlgorandLogoIcon from "theme/icons/AlgorandLogo";
import DollarSignIcon from "theme/icons/DollarSign";
import GBPIcon from "theme/icons/GBP";
import SelectedDotIcon from "theme/icons/SelectedDot";

const BaseCurrency = () => {
	const dispatch = useDispatch();

	const { appLanguage, themeColor, baseCurrency, setBaseCurrency } = useTheme();
	const { notify } = useNotification();

	const currencyList = [
		{
			icon: <DollarSignIcon fill={themeColor?.hex} />,
			"currency-code": "usd",
			language: appLanguage?.usDollar,
		},
		{
			icon: <EuroIcon fill={themeColor?.hex} />,
			"currency-code": "eur",
			language: appLanguage?.euro,
		},
		{
			icon: <GBPIcon fill={themeColor?.hex} />,
			"currency-code": "gbp",
			language: appLanguage?.pound,
		},
		{
			icon: <AlgorandLogoIcon fill={themeColor?.hex} />,
			"currency-code": "algo",
			language: appLanguage?.algorand,
		},
	];

	return (
		<Transition
			as={Fragment}
			appear={true}
			show={true}
			enter="transition-opacity duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
		>
			<div className="items-center justify-content w-[50%] flex-col px-5 space-y-2">
				{/* <div className={`flex items-center w-full space-x-4 border-b-2 ${themeColor?.border}`}>
					<h1 className={`w-full text-xl font-bold ${themeColor?.text} pb-1`}>Base Currency</h1>
				</div> */}

				<div className={`flex flex-col w-full items-center justify-start space-y-3 py-3`}>
					{currencyList &&
						currencyList.map((currencyItem, index) => (
							<div
								className={`flex w-full items-center justify-start space-x-4 cursor-pointer rounded-md border px-4 py-3`}
								key={index}
								onClick={() => {
									setBaseCurrency(currencyItem);
									dispatch(
										updateUserSettingsByUserID({ "base-currency": currencyItem["currency-code"] }, notify)
									);
								}}
							>
								<div className="w-4">{currencyItem?.icon}</div>
								<p className={`w-full text-sm font-bold capitalize ${themeColor?.text}`}>
									{currencyItem?.language}
								</p>
								{baseCurrency["currency-code"] === currencyItem["currency-code"] && (
									<SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />
								)}
							</div>
						))}
				</div>

				<div className={`flex flex-col w-full items-center justify-start space-y-3 py-3`}>
					<select
						className={`w-full smooth flex items-center justify-center py-2 px-3 space-x-2 rounded-md border ${themeColor?.text} hover:${themeColor?.bg} hover:text-gray-900 `}
						disabled
					>
						<option className={`${themeColor?.text}`}>{appLanguage?.other}</option>
					</select>
				</div>
			</div>
		</Transition>
	);
};

export default BaseCurrency;
